import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Alert,
  CircularProgress,
  IconButton,
  Tabs,
  Tab,
  Chip,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Delete as DeleteIcon, Edit as EditIcon, Add as AddIcon } from '@mui/icons-material';
import MainLayout from '../layouts/MainLayout';
import { apoliceService, Apolice, CreateApoliceDTO } from '../services/apoliceService';
import { pagamentoService, Pagamento, CreatePagamentoDTO } from '../services/pagamentoService';
import { objetoSeguradoService, ObjetoSeguro, CreateObjetoSeguroDTO } from '../services/objetoSeguradoService';
import { clienteService, Cliente } from '../services/clienteService';
import { colaboradorService, Colaborador } from '../services/colaboradorService';
import { ramoService } from '../services/ramoService';
import { empresaService, Empresa } from '../services/empresaService';
import { comissaoCorretoraService } from '../services/comissaoCorretoraService';
import { formatarMoeda } from '../utils/formatters';
import { toast } from 'react-toastify';
import api from '../services/api';
import { ComissaoColaborador } from '../types/comissaoColaborador';
import { ComissaoCorretora } from '../types/comissaoCorretora';
import { pagamentoCorretagemService } from '../services/pagamentoCorretagemService';
import { PagamentoCorretagem, CreatePagamentoCorretagemDTO, UpdatePagamentoCorretagemDTO, CreateMultiplePagamentosDTO, ResumoCorretagem } from '../types/pagamentoCorretagem';
import { useForm, Controller } from 'react-hook-form';

import { useAuthContext } from '../contexts/AuthContext';

import { objetoSeguroREService,ObjetoSeguroRE,CreateObjetoSeguroREDto } from '../services/objetoSeguroREService';

import { Cobertura, getCoberturas } from '../services/coberturaService';
import { NumericFormat } from 'react-number-format';
interface Seguradora {
  id: number;
  nome: string;
}

interface Ramo {
  id: number;
  nome: string;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const EditarApolice: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { hasPermission } = useAuthContext();
  

  const [apolice, setApolice] = useState<Apolice | null>(null);
  const [clientes, setClientes] = useState<Cliente[]>([]);
  const [seguradoras, setSeguradoras] = useState<Seguradora[]>([]);
  const [ramos, setRamos] = useState<Ramo[]>([]);
  const [colaboradores, setColaboradores] = useState<Colaborador[]>([]);
  const [loadingColaboradores, setLoadingColaboradores] = useState(false);
  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [loadingEmpresas, setLoadingEmpresas] = useState(false);

  // Tabs
  const [tabValue, setTabValue] = useState(0);
  const [tabValueComissao, setTabValueComissao] = useState(0);

  // Pagamentos
  const [pagamentos, setPagamentos] = useState<Pagamento[]>([]);
  const [loadingPagamentos, setLoadingPagamentos] = useState(false);
  const [pagamentoForm, setPagamentoForm] = useState<CreatePagamentoDTO>({
    numeroParcela: 1,
    valorParcela: 0,
    dataVencimento: '',
    dataPagamento: '',
    status: 'Pendente',
    formaPagamento: '',
    observacao: '',
    apoliceId: 0
  });

  //hooks dos formularios
  const objetoAsseguradoForm = useForm();

  const {
    register,
    handleSubmit: handleSubmitApolice,
    formState: { errors },
    control,
    reset,
    watch
  } = useForm<CreateApoliceDTO & { gerarParcelasAutomaticamente: boolean }>({
    defaultValues: {
      status: 'Ativa',
      quantidadeParcelas: 1,
    }
  });

  // Dialog de edição de pagamento
  const [openEditPagamento, setOpenEditPagamento] = useState(false);
  const [pagamentoEditando, setPagamentoEditando] = useState<Pagamento | null>(null);
  const [editPagamentoForm, setEditPagamentoForm] = useState({
    numeroParcela: 1,
    valorParcela: 0,
    dataVencimento: '',
    dataPagamento: '',
    status: 'Pendente' as 'Pendente' | 'Pago' | 'Atrasado',
    formaPagamento: '',
    observacao: '',
  });

  // Dialog de criação de pagamento
  const [openCreatePagamento, setOpenCreatePagamento] = useState(false);

  // Adicionar estado para as comissões
  const [comissoesColaborador, setComissoesColaborador] = useState<ComissaoColaborador[]>([]);
  const [loadingComissoes, setLoadingComissoes] = useState(false);
  const [comissoesCorretora, setComissoesCorretora] = useState<ComissaoCorretora[]>([]);
  const [loadingComissoesCorretora, setLoadingComissoesCorretora] = useState(false);

  // Dialog de edição de comissão
  const [openEditComissao, setOpenEditComissao] = useState(false);
  const [comissaoEditando, setComissaoEditando] = useState<ComissaoColaborador | null>(null);
  const [editComissaoForm, setEditComissaoForm] = useState({
    valor: 0,
    dataPrevista: '',
    dataPagamento: '',
    status: 'Pendente' as 'Pendente' | 'Pago',
  });

  // Dialog de criação de comissão em lote
  const [openBulkComissao, setOpenBulkComissao] = useState(false);
  const [bulkComissaoType, setBulkComissaoType] = useState<'colaborador' | 'corretora' | null>(null);
  const [bulkComissaoForm, setBulkComissaoForm] = useState({
    quantidadeParcelas: 1,
    valorParcela: 0,
    dataInicio: '',
  });
  const [bulkComissaoSaving, setBulkComissaoSaving] = useState(false);



  // Pagamentos de Corretagem
  const [pagamentosCorretagem, setPagamentosCorretagem] = useState<PagamentoCorretagem[]>([]);
  const [loadingPagamentosCorretagem, setLoadingPagamentosCorretagem] = useState(false);
  const [selectedPagamentosCorretagem, setSelectedPagamentosCorretagem] = useState<number[]>([]);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [pagamentoToDelete, setPagamentoToDelete] = useState<number | null>(null);
  const [resumoCorretagem, setResumoCorretagem] = useState<ResumoCorretagem | null>(null);

  // Dialog de criação de parcelas de corretagem
  const [openCriarParcelas, setOpenCriarParcelas] = useState(false);
      const [criarParcelasForm, setCriarParcelasForm] = useState<CreateMultiplePagamentosDTO>({
        apoliceId: 0,
        quantidadeParcelas: 1,
        valorParcela: 0,
        dataInicio: ''
    });

  // Dialog de edição de pagamento de corretagem
  const [openEditPagamentoCorretagem, setOpenEditPagamentoCorretagem] = useState(false);
  const [pagamentoCorretagemEditando, setPagamentoCorretagemEditando] = useState<PagamentoCorretagem | null>(null);
  const [editPagamentoCorretagemForm, setEditPagamentoCorretagemForm] = useState<UpdatePagamentoCorretagemDTO>({
    numeroParcela: 1,
    valorParcela: 0,
    dataVencimento: '',
    dataPagamento: '',
    status: 'Pendente',
    formaPagamento: undefined,
    observacao: '',
    valorComissao: 0
  });

  // Estado para erros de validação
  const [validationErrors, setValidationErrors] = useState<{[key: string]: boolean}>({});

  // Objetos Segurados
  const [objetosSegurados, setObjetosSegurados] = useState<ObjetoSeguro[]>([]);
  const [loadingObjetos, setLoadingObjetos] = useState(false);

  // Dialog de Objeto Segurado
  const [openObjetoDialog, setOpenObjetoDialog] = useState(false);
  const [objetoEditando, setObjetoEditando] = useState<ObjetoSeguro | null>(null);
  const [objetoForm, setObjetoForm] = useState<CreateObjetoSeguroDTO>({
    placa: '',
    chassi: '',
    marca: '',
    modelo: '',
    ano_fabricacao: new Date().getFullYear(),
    ano_modelo: new Date().getFullYear(),
    lotacao_oficial: 0,
    combustivel: '',
    carroceria: '',
    qtd_eixos: 0,
    qtd_portas: 0,
    valor_de_mercado: 0,
    outros: '',
  });
  const [objetoValidationErrors, setObjetoValidationErrors] = useState<{ [key: string]: boolean }>({});
  const [savingObjeto, setSavingObjeto] = useState(false);

  // Dialog de exclusão de objeto segurado
  const [openDeleteObjetoConfirm, setOpenDeleteObjetoConfirm] = useState(false);
  const [objetoToDelete, setObjetoToDelete] = useState<ObjetoSeguro | null>(null);

  // Objetos de Resseguro (RE)
  const [objetosRE, setObjetosRE] = useState<ObjetoSeguroRE[]>([]);
  const [loadingObjetosRE, setLoadingObjetosRE] = useState(false);
  const [openObjetoREDialog, setOpenObjetoREDialog] = useState(false);
  const [coberturasDisponiveis, setCoberturasDisponiveis] = useState<Cobertura[]>([]);
  const [objetoREForm, setObjetoREForm] = useState<CreateObjetoSeguroREDto>({
    descricao: '',
    coberturas: [{ coberturaId: 0, valor: 0 }],
  });
  const [savingObjetoRE, setSavingObjetoRE] = useState(false);
  const [openDeleteObjetoREConfirm, setOpenDeleteObjetoREConfirm] = useState(false);
  const [objetoREToDelete, setObjetoREToDelete] = useState<ObjetoSeguroRE | null>(null);

  const carregarCoberturasDisponiveis = async () => {
    const data = await getCoberturas();
    setCoberturasDisponiveis(data);
  };
  const carregarColaboradores = async () => {
    setLoadingColaboradores(true);
    try {
      const data = await colaboradorService.listar();
      setColaboradores(data);
    } catch (error) {
      setColaboradores([]);
    } finally {
      setLoadingColaboradores(false);
    }
  };

  const carregarEmpresas = async () => {
    setLoadingEmpresas(true);
    try {
      const data = await empresaService.listar();
      setEmpresas(data);
    } catch (error) {
      setEmpresas([]);
    } finally {
      setLoadingEmpresas(false);
    }
  };

  const carregarPagamentos = async (apoliceId: number) => {
    if (!apoliceId) return;
    
    setLoadingPagamentos(true);
    try {
      const data = await pagamentoService.listarPorApolice(apoliceId);
      setPagamentos(data);
    } catch (error) {
      console.error('Erro ao carregar pagamentos:', error);
      toast.error('Erro ao carregar pagamentos. Por favor, tente novamente.');
    } finally {
      setLoadingPagamentos(false);
    }
  };

  const carregarPagamentosCorretagem = async (apoliceId: number) => {
    if (!apoliceId) return;
    
    setLoadingPagamentosCorretagem(true);
    try {
      const data = await pagamentoCorretagemService.findByApoliceId(apoliceId);
      setPagamentosCorretagem(data);
    } catch (error) {
      console.error('Erro ao carregar pagamentos de corretagem:', error);
      toast.error('Erro ao carregar pagamentos de corretagem. Por favor, tente novamente.');
    } finally {
      setLoadingPagamentosCorretagem(false);
    }
  };

  const carregarResumoCorretagem = async (apoliceId: number) => {
    if (!apoliceId) return;
    
    try {
      const data = await pagamentoCorretagemService.getResumoCorretagem(apoliceId);
      setResumoCorretagem(data);
    } catch (error) {
      console.error('Erro ao carregar resumo de corretagem:', error);
      toast.error('Erro ao carregar resumo de corretagem. Por favor, tente novamente.');
    }
  };

  const carregarObjetosSegurados = async (apoliceId: number) => {
    if (!apoliceId) return;

    setLoadingObjetos(true);
    try {
      const response = await objetoSeguradoService.listarPorApolice(apoliceId);
      setObjetosSegurados(response.data);
    } catch (error) {
      console.error('Erro ao carregar objetos segurados:', error);
      toast.error('Erro ao carregar os objetos segurados.');
    } finally {
      setLoadingObjetos(false);
    }
  };

  const carregarObjetosRE = async (apoliceId: number) => {
    if (!apoliceId) return;

    setLoadingObjetosRE(true);
    try {
      const data = await objetoSeguroREService.listarPorApolice(apoliceId);
      setObjetosRE(data);
    } catch (error) {
      console.error('Erro ao carregar objetos de RE:', error);
      toast.error('Erro ao carregar os objetos de RE.');
    } finally {
      setLoadingObjetosRE(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Carregar dados da apólice
        if (id) {
          const apoliceData = await apoliceService.getApolice(parseInt(id));
          reset({ // Usando reset do react-hook-form para popular o formulário
            numero: apoliceData.numero,
            produto: apoliceData.produto || '',
            status: apoliceData.status,
            proposta: apoliceData.proposta || '',
            dataEmissao: apoliceData.dataEmissao?.split('T')[0] || '',
            seguradoraAnterior: apoliceData.seguradoraAnterior ? { id: apoliceData.seguradoraAnterior.id } : undefined,
            apoliceAnterior: apoliceData.apoliceAnterior || '',
            formaPagamento: apoliceData.formaPagamento || undefined,
            propostaAssinada: apoliceData.propostaAssinada || false,
            apoliceConferida: apoliceData.apoliceConferida || false,
            dataInicio: apoliceData.dataInicio.split('T')[0],
            dataFim: apoliceData.dataFim.split('T')[0],
            premioLiquido: apoliceData.premioLiquido ?? 0,
            premioBruto: apoliceData.premioBruto ?? '',
            iof: apoliceData.iof ?? '',
            quantidadeParcelas: apoliceData.quantidadeParcelas,
                          comissaoVendedor: apoliceData.comissaoVendedor ?? null,
              comissaoCorretora: apoliceData.comissaoCorretora ?? null,
              repasse: apoliceData.repasse ?? 0,
              cliente: { id: apoliceData.cliente.id },
            seguradora: { id: apoliceData.seguradora.id },
            ramo: { id: apoliceData.ramo.id },
            vendedor: apoliceData.vendedor ? { id: apoliceData.vendedor.id } : undefined,
            corretora: apoliceData.corretora ? { id: apoliceData.corretora.id } : undefined,
            dataPrimeiroPagamento: apoliceData.dataPrimeiroPagamento ? apoliceData.dataPrimeiroPagamento.split('T')[0] : '',
            dataSegundoPagamento: apoliceData.dataSegundoPagamento ? apoliceData.dataSegundoPagamento.split('T')[0] : '',
            gerarParcelasAutomaticamente: false,
            ci: apoliceData.ci || undefined,
          });
          setApolice(apoliceData);
          
          // Carregar pagamentos da apólice
          carregarPagamentos(apoliceData.id);

          // Carregar pagamentos de corretagem
          carregarPagamentosCorretagem(apoliceData.id);
          carregarResumoCorretagem(apoliceData.id);

          // Carregar objetos segurados
          carregarObjetosSegurados(apoliceData.id);

          // Carregar objetos de resseguro
          carregarObjetosRE(apoliceData.id);

          setLoadingComissoes(true);
          try {
            const comissoes = await apoliceService.listarComissoesColaborador(apoliceData.id);
            setComissoesColaborador(comissoes);
          } catch {
            setComissoesColaborador([]);
          } finally {
            setLoadingComissoes(false);
          }

          setLoadingComissoesCorretora(true);
          try {
            const comissoesCorretora = await comissaoCorretoraService.listarPorApolice(apoliceData.id);
            setComissoesCorretora(comissoesCorretora);
          } catch {
            setComissoesCorretora([]);
          } finally {
            setLoadingComissoesCorretora(false);
          }
        }

        // Carregar dados de relacionamento
        const seguradorasResponse = await api.get('/seguradoras');
        setSeguradoras(seguradorasResponse.data);

        const [clientesData, ramosData] = await Promise.all([
          clienteService.listar(),
          ramoService.listarRamos(),
          carregarColaboradores(),
          carregarEmpresas(),
          carregarCoberturasDisponiveis(),
        ]);

        setClientes(clientesData.data);
        setRamos(ramosData);
      } catch (err) {
        setError('Erro ao carregar dados da apólice');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleTabChangeComissao = (event: React.SyntheticEvent, newValue: number) => {
    setTabValueComissao(newValue);
  };

  const handleGerarParcelas = async () => {
    if (!apolice) return;
    
    try {
      const formData = watch(); // Pega os valores atuais do formulário

      // Converter valores para números e validar
      const premioLiquido = Number(formData.premioLiquido) || 0;
      const iofValue = typeof formData.iof === 'string' ? parseFloat(formData.iof) : formData.iof;
      const iof = Number(iofValue) || 0;
      const quantidadeParcelas = Number(formData.quantidadeParcelas) || 1;
      
      const premioTotal = premioLiquido + iof;
      
      // Validar se o valor total é válido
      if (premioTotal <= 0) {
        toast.error('O valor total do prêmio deve ser maior que zero.');
        return;
      }
      
      if (quantidadeParcelas <= 0) {
        toast.error('A quantidade de parcelas deve ser maior que zero.');
        return;
      }
      
      await pagamentoService.gerarParcelas({
        apoliceId: apolice.id,
        quantidadeParcelas: quantidadeParcelas,
        valorTotal: premioTotal
      });
      toast.success('Parcelas geradas com sucesso!');
      // Refresh da página após gerar parcelas
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error('Erro ao gerar parcelas:', error);
      toast.error('Erro ao gerar parcelas. Por favor, tente novamente.');
    }
  };

  const handleCriarPagamento = async () => {
    if (!apolice) return;
    
    try {
      // Preparar dados para envio, convertendo strings vazias para null
      const dadosParaEnvio = {
        ...pagamentoForm,
        apoliceId: apolice.id,
        dataVencimento: pagamentoForm.dataVencimento || null,
        dataPagamento: pagamentoForm.dataPagamento || null,
      };

      await pagamentoService.criar(dadosParaEnvio);
      toast.success('Pagamento criado com sucesso!');
      handleFecharCreatePagamento();
      carregarPagamentos(apolice.id);
    } catch (error) {
      console.error('Erro ao criar pagamento:', error);
      toast.error('Erro ao criar pagamento. Por favor, tente novamente.');
    }
  };

  const handleExcluirPagamento = async (pagamentoId: number) => {
    if (window.confirm('Tem certeza que deseja excluir este pagamento?')) {
      try {
        await pagamentoService.excluir(pagamentoId);
        toast.success('Pagamento excluído com sucesso!');
        if (apolice) {
          carregarPagamentos(apolice.id);
        }
      } catch (error) {
        console.error('Erro ao excluir pagamento:', error);
        toast.error('Erro ao excluir pagamento. Por favor, tente novamente.');
      }
    }
  };

  const handleEditarPagamento = (pagamento: Pagamento) => {
    setPagamentoEditando(pagamento);
    setEditPagamentoForm({
      numeroParcela: pagamento.numeroParcela,
      valorParcela: pagamento.valorParcela,
      dataVencimento: pagamento.dataVencimento.split('T')[0],
      dataPagamento: pagamento.dataPagamento ? pagamento.dataPagamento.split('T')[0] : '',
      status: pagamento.status,
      formaPagamento: pagamento.formaPagamento || '',
      observacao: pagamento.observacao || '',
    });
    setOpenEditPagamento(true);
  };

  const handleFecharEditPagamento = () => {
    setOpenEditPagamento(false);
    setPagamentoEditando(null);
    setEditPagamentoForm({
      numeroParcela: 1,
      valorParcela: 0,
      dataVencimento: '',
      dataPagamento: '',
      status: 'Pendente',
      formaPagamento: '',
      observacao: '',
    });
  };

  const handleSalvarEditPagamento = async () => {
    if (!pagamentoEditando || !apolice) return;

    try {
      // Preparar dados para envio, convertendo strings vazias para null
      const dadosParaEnvio = {
        ...editPagamentoForm,
        apoliceId: apolice.id,
        dataVencimento: editPagamentoForm.dataVencimento || null,
        dataPagamento: editPagamentoForm.dataPagamento || null,
      };

      await pagamentoService.atualizar(pagamentoEditando.id, dadosParaEnvio);
      toast.success('Pagamento atualizado com sucesso!');
      handleFecharEditPagamento();
      carregarPagamentos(apolice.id);
    } catch (error) {
      console.error('Erro ao atualizar pagamento:', error);
      toast.error('Erro ao atualizar pagamento. Por favor, tente novamente.');
    }
  };

  const handleAbrirCreatePagamento = () => {
    setPagamentoForm({
      numeroParcela: 1,
      valorParcela: 0,
      dataVencimento: '',
      dataPagamento: '',
      status: 'Pendente',
      formaPagamento: '',
      observacao: '',
      apoliceId: 0
    });
    setOpenCreatePagamento(true);
  };

  const handleFecharCreatePagamento = () => {
    setOpenCreatePagamento(false);
    setPagamentoForm({
      numeroParcela: 1,
      valorParcela: 0,
      dataVencimento: '',
      dataPagamento: '',
      status: 'Pendente',
      formaPagamento: '',
      observacao: '',
      apoliceId: 0
    });
  };

  // Handlers para comissões
  const handleEditarComissao = (comissao: ComissaoColaborador) => {
    setComissaoEditando(comissao);
    setEditComissaoForm({
      valor: comissao.valor,
      dataPrevista: comissao.dataPrevista || '',
      dataPagamento: comissao.dataPagamento || '',
      status: comissao.status,
    });
    setOpenEditComissao(true);
  };

  const handleFecharEditComissao = () => {
    setOpenEditComissao(false);
    setComissaoEditando(null);
    setEditComissaoForm({
      valor: 0,
      dataPrevista: '',
      dataPagamento: '',
      status: 'Pendente',
    });
  };

  const handleSalvarEditComissao = async () => {
    if (!comissaoEditando || !id) return;

    try {
      await apoliceService.atualizarComissaoColaborador(
        parseInt(id),
        comissaoEditando.id,
        editComissaoForm
      );

      // Recarregar comissões
      const comissoes = await apoliceService.listarComissoesColaborador(parseInt(id));
      setComissoesColaborador(comissoes);

      toast.success('Comissão atualizada com sucesso!');
      handleFecharEditComissao();
    } catch (error) {
      console.error('Erro ao atualizar comissão:', error);
      toast.error('Erro ao atualizar comissão');
    }
  };

  const handleExcluirComissao = async (comissaoId: number) => {
    if (!id) return;

    if (window.confirm('Tem certeza que deseja excluir esta comissão?')) {
      try {
        await apoliceService.excluirComissaoColaborador(parseInt(id), comissaoId);

        // Recarregar comissões
        const comissoes = await apoliceService.listarComissoesColaborador(parseInt(id));
        setComissoesColaborador(comissoes);

        toast.success('Comissão excluída com sucesso!');
      } catch (error) {
        console.error('Erro ao excluir comissão:', error);
        toast.error('Erro ao excluir comissão');
      }
    }
  };

  // Funções para comissões de corretora
  const [openEditComissaoCorretora, setOpenEditComissaoCorretora] = useState(false);
  const [comissaoCorretoraEditando, setComissaoCorretoraEditando] = useState<ComissaoCorretora | null>(null);
  const [editComissaoCorretoraForm, setEditComissaoCorretoraForm] = useState({
    valor: 0,
    dataPrevista: '',
    dataPagamento: '',
    status: 'Pendente' as 'Pendente' | 'Pago',
  });

  const handleEditarComissaoCorretora = (comissao: ComissaoCorretora) => {
    setComissaoCorretoraEditando(comissao);
    setEditComissaoCorretoraForm({
      valor: comissao.valor,
      dataPrevista: comissao.dataPrevista ? comissao.dataPrevista.split('T')[0] : '',
      dataPagamento: comissao.dataPagamento ? comissao.dataPagamento.split('T')[0] : '',
      status: comissao.status,
    });
    setOpenEditComissaoCorretora(true);
  };

  const handleFecharEditComissaoCorretora = () => {
    setOpenEditComissaoCorretora(false);
    setComissaoCorretoraEditando(null);
  };

  const handleSalvarEditComissaoCorretora = async () => {
    if (!comissaoCorretoraEditando) return;
    
    try {
      await comissaoCorretoraService.atualizar(comissaoCorretoraEditando.id, editComissaoCorretoraForm);
      toast.success('Comissão da corretora atualizada com sucesso!');
      handleFecharEditComissaoCorretora();
      // Recarregar comissões
      if (id) {
        const comissoesCorretora = await comissaoCorretoraService.listarPorApolice(parseInt(id));
        setComissoesCorretora(comissoesCorretora);
      }
    } catch (error) {
      console.error('Erro ao atualizar comissão da corretora:', error);
      toast.error('Erro ao atualizar comissão da corretora. Por favor, tente novamente.');
    }
  };

  const handleExcluirComissaoCorretora = async (comissaoId: number) => {
    if (!id) return;

    if (window.confirm('Tem certeza que deseja excluir esta comissão da corretora?')) {
      try {
        await comissaoCorretoraService.excluir(comissaoId);
        toast.success('Comissão da corretora excluída com sucesso!');
        // Recarregar comissões
        const comissoesCorretora = await comissaoCorretoraService.listarPorApolice(parseInt(id));
        setComissoesCorretora(comissoesCorretora);
      } catch (error) {
        console.error('Erro ao excluir comissão da corretora:', error);
        toast.error('Erro ao excluir comissão da corretora. Por favor, tente novamente.');
      }
    }
  };

  // Handlers para pagamentos de corretagem
  const handleEditarPagamentoCorretagem = (pagamento: PagamentoCorretagem) => {
    setPagamentoCorretagemEditando(pagamento);
    setEditPagamentoCorretagemForm({
      numeroParcela: pagamento.numeroParcela,
      valorParcela: pagamento.valorParcela,
      dataVencimento: pagamento.dataVencimento.split('T')[0],
      dataPagamento: pagamento.dataPagamento ? pagamento.dataPagamento.split('T')[0] : '',
      status: pagamento.status,
      formaPagamento: pagamento.formaPagamento,
      observacao: pagamento.observacao || '',
      valorComissao: pagamento.valorComissao,
    });
    setOpenEditPagamentoCorretagem(true);
  };

  const handleFecharEditPagamentoCorretagem = () => {
    setOpenEditPagamentoCorretagem(false);
    setPagamentoCorretagemEditando(null);
    setEditPagamentoCorretagemForm({
      numeroParcela: 1,
      valorParcela: 0,
      dataVencimento: '',
      dataPagamento: '',
      status: 'Pendente',
      formaPagamento: undefined,
      observacao: '',
      valorComissao: 0
    });
  };

  const handleSalvarEditPagamentoCorretagem = async () => {
    if (!pagamentoCorretagemEditando || !apolice) return;

    try {
      const dadosParaEnvio = {
        ...editPagamentoCorretagemForm,
        dataPagamento: editPagamentoCorretagemForm.dataPagamento || null, // Converte string vazia para null
      };
      await pagamentoCorretagemService.update(pagamentoCorretagemEditando.id, dadosParaEnvio);
      toast.success('Pagamento de corretagem atualizado com sucesso!');
      handleFecharEditPagamentoCorretagem();
      carregarPagamentosCorretagem(apolice.id);
      carregarResumoCorretagem(apolice.id);
    } catch (error) {
      console.error('Erro ao atualizar pagamento de corretagem:', error);
      toast.error('Erro ao atualizar pagamento de corretagem. Por favor, tente novamente.');
    }
  };

  const handleExcluirPagamentoCorretagem = (pagamentoId: number) => {
    // Prepara para exclusão individual e abre o modal de confirmação
    setPagamentoToDelete(pagamentoId);
    setOpenDeleteConfirm(true);
  };

  const handleSelectAllPagamentosCorretagem = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = pagamentosCorretagem.map((p) => p.id);
      setSelectedPagamentosCorretagem(newSelecteds);
      return;
    }
    setSelectedPagamentosCorretagem([]);
  };

  const handleSelectOnePagamentoCorretagem = (id: number) => {
    const selectedIndex = selectedPagamentosCorretagem.indexOf(id);
    let newSelected: number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedPagamentosCorretagem, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedPagamentosCorretagem.slice(1));
    } else if (selectedIndex === selectedPagamentosCorretagem.length - 1) {
      newSelected = newSelected.concat(selectedPagamentosCorretagem.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedPagamentosCorretagem.slice(0, selectedIndex),
        selectedPagamentosCorretagem.slice(selectedIndex + 1),
      );
    }
    setSelectedPagamentosCorretagem(newSelected);
  };

  const isPagamentoCorretagemSelected = (id: number) => selectedPagamentosCorretagem.indexOf(id) !== -1;

  const handleConfirmDelete = async () => {
    if (!apolice) return;
    try {
      if (pagamentoToDelete) {
        // Lógica para exclusão de uma única parcela
        await pagamentoCorretagemService.delete(pagamentoToDelete);
        toast.success('Pagamento de corretagem excluído com sucesso!');
      } else if (selectedPagamentosCorretagem.length > 0) {
        // Lógica para exclusão de múltiplas parcelas
        await pagamentoCorretagemService.deleteMultiple(selectedPagamentosCorretagem);
        toast.success('Parcelas selecionadas foram excluídas com sucesso!');
        setSelectedPagamentosCorretagem([]);
      }
      // Recarrega os dados em ambos os casos
      carregarPagamentosCorretagem(apolice.id);
      carregarResumoCorretagem(apolice.id);
    } catch (error) {
      console.error('Erro ao excluir parcelas de corretagem:', error);
      toast.error('Erro ao excluir as parcelas selecionadas.');
    } finally {
      setOpenDeleteConfirm(false);
      setPagamentoToDelete(null); // Limpa o estado de exclusão individual
    }
  };

      const limparFormularioCriarParcelas = () => {
        setCriarParcelasForm({
            apoliceId: 0,
            quantidadeParcelas: 1,
            valorParcela: 0,
            dataInicio: ''
        });
    };

  const handleCriarParcelas = async () => {
    if (!apolice) return;

    // Validação no frontend para feedback rápido ao usuário
    if (criarParcelasForm.quantidadeParcelas <= 0) {
      toast.error('A quantidade de parcelas deve ser maior que zero.');
      return;
    }

    if (criarParcelasForm.valorParcela <= 0) {
      toast.error('O valor da parcela deve ser maior que zero.');
      return;
    }

    try {
                  const dados: CreateMultiplePagamentosDTO = {
                apoliceId: apolice.id,
                quantidadeParcelas: criarParcelasForm.quantidadeParcelas,
                valorParcela: criarParcelasForm.valorParcela,
                dataInicio: criarParcelasForm.dataInicio && criarParcelasForm.dataInicio.trim() !== '' ? criarParcelasForm.dataInicio : undefined
            };
      
      await pagamentoCorretagemService.createMultiplePagamentos(dados);
      toast.success('Parcelas de corretagem criadas com sucesso!');
      setOpenCriarParcelas(false);
      limparFormularioCriarParcelas();
      carregarPagamentosCorretagem(apolice.id);
      carregarResumoCorretagem(apolice.id);
    } catch (error: any) {
      console.error('Erro ao criar parcelas de corretagem:', error);
      // Tenta extrair a mensagem de erro específica da resposta da API,
      // caso contrário, exibe uma mensagem genérica.
      const errorMessage = error.response?.data?.message || 'Erro ao criar parcelas de corretagem. Por favor, tente novamente.';
      toast.error(errorMessage);
    }
  };

  const handleOpenBulkComissao = (type: 'colaborador' | 'corretora') => {
    setBulkComissaoType(type);
    setBulkComissaoForm({
      quantidadeParcelas: 1,
      valorParcela: 0,
      dataInicio: '',
    });
    setOpenBulkComissao(true);
  };

  const handleCloseBulkComissao = () => {
    setOpenBulkComissao(false);
    setBulkComissaoType(null);
  };

  const handleCreateBulkComissao = async () => {
    if (!id || !bulkComissaoType) return;

    if (bulkComissaoForm.quantidadeParcelas <= 0 || bulkComissaoForm.valorParcela <= 0) {
      toast.error('Quantidade e valor da parcela devem ser maiores que zero.');
      return;
    }

    setBulkComissaoSaving(true);
    try {
      const endpoint = bulkComissaoType === 'colaborador'
        ? `/apolices/${id}/comissoes-colaborador/bulk`
        : `/apolices/${id}/comissoes-corretora/bulk`;

      await api.post(endpoint, bulkComissaoForm);

      toast.success('Parcelas de comissão criadas com sucesso!');
      handleCloseBulkComissao();

      // Recarregar a lista de comissões apropriada
      if (bulkComissaoType === 'colaborador') {
        const comissoes = await apoliceService.listarComissoesColaborador(parseInt(id));
        setComissoesColaborador(comissoes);
      } else {
        const comissoesCorretora = await comissaoCorretoraService.listarPorApolice(parseInt(id));
        setComissoesCorretora(comissoesCorretora);
      }

    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Erro ao criar parcelas de comissão.';
      toast.error(errorMessage);
      console.error('Erro ao criar parcelas de comissão:', error);
    } finally {
      setBulkComissaoSaving(false);
    }
  };

  // Handlers para Objeto Segurado
  const handleOpenAddObjeto = () => {
    setObjetoEditando(null);
    setObjetoForm({
      placa: '',
      chassi: '',
      marca: '',
      modelo: '',
      ano_fabricacao: new Date().getFullYear(),
      ano_modelo: new Date().getFullYear(),
      lotacao_oficial: 0,
      combustivel: '',
      carroceria: '',
      qtd_eixos: 0,
      qtd_portas: 0,
      valor_de_mercado: 0,
      outros: '',
    });
    setObjetoValidationErrors({});
    setOpenObjetoDialog(true);
  };

  const handleOpenEditObjeto = (veiculo: ObjetoSeguro) => {
    setObjetoEditando(veiculo);
    // Usar o reset do react-hook-form para popular o formulário com os dados do veículo
    objetoAsseguradoForm.reset(veiculo);
    setOpenObjetoDialog(true);
  };

  const handleCloseObjetoDialog = () => {
    setOpenObjetoDialog(false);
    setObjetoEditando(null);
    objetoAsseguradoForm.reset();
  };

  const handleSaveObjeto = async (data:any) => {
  if (!id) return;

  setSavingObjeto(true);
  try {
    const payload = {
      ...data,
      valor_de_mercado: data.valor_de_mercado || undefined,
      qtd_eixos: data.qtd_eixos || undefined,
      qtd_portas: data.qtd_portas || undefined,
    };

    if (objetoEditando) {
      await objetoSeguradoService.atualizar(parseInt(id), objetoEditando.id, payload);
      toast.success('Objeto segurado atualizado com sucesso!');
    } else {
      await objetoSeguradoService.criar(parseInt(id), payload);
      toast.success('Objeto segurado adicionado com sucesso!');
    }

    handleCloseObjetoDialog();
    carregarObjetosSegurados(parseInt(id));
  } catch (error) {
    console.error('Erro ao salvar objeto segurado:', error);
    toast.error('Erro ao salvar objeto segurado. Tente novamente.');
  } finally {
    setSavingObjeto(false);
  }
};

  const handleOpenDeleteObjeto = (veiculo: ObjetoSeguro) => {
    setObjetoToDelete(veiculo);
    setOpenDeleteObjetoConfirm(true);
  };

  const handleCloseDeleteObjeto = () => {
    setOpenDeleteObjetoConfirm(false);
    setObjetoToDelete(null);
  };

  const handleConfirmDeleteObjeto = async () => {
    if (!id || !objetoToDelete) return;

    try {
      await objetoSeguradoService.excluir(parseInt(id), objetoToDelete.id);
      toast.success('Objeto segurado excluído com sucesso!');
      handleCloseDeleteObjeto();
      carregarObjetosSegurados(parseInt(id));
    } catch (error) {
      console.error('Erro ao excluir objeto segurado:', error);
      toast.error('Erro ao excluir objeto segurado. Tente novamente.');
    }
  };

  const handleObjetoFormChange = (field: string, value: any) => {
    setObjetoForm(prev => ({ ...prev, [field]: value }));
    if (objetoValidationErrors[field]) {
      setObjetoValidationErrors(prev => ({ ...prev, [field]: false }));
    }
  };

  // Handlers para Objeto de Resseguro (RE)
  const handleOpenObjetoREDialog = () => {
    setObjetoREForm({
      descricao: '',
      coberturas: [{ coberturaId: 0, valor: 0 }],
    });
    setOpenObjetoREDialog(true);
  };

  const handleCloseObjetoREDialog = () => {
    setOpenObjetoREDialog(false);
  };

  const handleObjetoREFormChange = (field: 'descricao', value: string) => {
    setObjetoREForm(prev => ({ ...prev, [field]: value }));
  };

  const handleCoberturaREChange = (index: number, field: 'coberturaId' | 'valor', value: any) => {
    const novasCoberturas = [...objetoREForm.coberturas];
    novasCoberturas[index] = { ...novasCoberturas[index], [field]: value };
    setObjetoREForm(prev => ({ ...prev, coberturas: novasCoberturas }));
  };

  const adicionarCampoCoberturaRE = () => {
    setObjetoREForm(prev => ({
      ...prev,
      coberturas: [...prev.coberturas, { coberturaId: 0, valor: 0 }],
    }));
  };

  const removerCampoCoberturaRE = (index: number) => {
    const novasCoberturas = objetoREForm.coberturas.filter((_, i) => i !== index);
    setObjetoREForm(prev => ({ ...prev, coberturas: novasCoberturas }));
  };

  const handleSaveObjetoRE = async () => {
    if (!id) return;

    if (!objetoREForm.descricao.trim()) {
      toast.warn('A descrição do objeto de resseguro é obrigatória.');
      return;
    }

    setSavingObjetoRE(true);
    try {
      await objetoSeguroREService.criar(parseInt(id), objetoREForm);
      toast.success('Objeto de resseguro criado com sucesso!');
      handleCloseObjetoREDialog();
      carregarObjetosRE(parseInt(id));
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Erro ao salvar objeto de resseguro.';
      toast.error(errorMessage);
      console.error('Erro ao salvar objeto de resseguro:', error);
    } finally {
      setSavingObjetoRE(false);
    }
  };

  const handleOpenDeleteObjetoRE = (objeto: ObjetoSeguroRE) => {
    setObjetoREToDelete(objeto);
    setOpenDeleteObjetoREConfirm(true);
  };

  const handleCloseDeleteObjetoRE = () => {
    setOpenDeleteObjetoREConfirm(false);
    setObjetoREToDelete(null);
  };

  const handleConfirmDeleteObjetoRE = async () => {
    if (!id || !objetoREToDelete) return;

    try {
      await objetoSeguroREService.excluir(parseInt(id), objetoREToDelete.id);
      toast.success('Objeto de resseguro excluído com sucesso!');
      handleCloseDeleteObjetoRE();
      carregarObjetosRE(parseInt(id));
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Erro ao excluir objeto de resseguro.';
      toast.error(errorMessage);
      console.error('Erro ao excluir objeto de resseguro:', error);
    }
  };

  const onFormSubmit = async (data: CreateApoliceDTO & { gerarParcelasAutomaticamente: boolean }) => {
    
    if (!id) return;

    // Validação dos campos obrigatórios
    const erros: string[] = [];
    const novosErros: {[key: string]: boolean} = {};
    
    try {
      setSaving(true);
      setError('');
      setSuccess('');

      // Converte campos de data vazios para null antes de enviar
      const dadosParaEnviar = { ...data };
      console.log(dadosParaEnviar)
      if (dadosParaEnviar.dataEmissao === "") dadosParaEnviar.dataEmissao = null;
      if (dadosParaEnviar.dataPrimeiroPagamento === ' ') dadosParaEnviar.dataPrimeiroPagamento = null;
      if (dadosParaEnviar.dataSegundoPagamento === ' ') dadosParaEnviar.dataSegundoPagamento = null;

      console.log(dadosParaEnviar.dataEmissao)
      console.log("sei la essa porra")
      console.log(data)
      await apoliceService.atualizar(parseInt(id), {
        ...data,
        premioBruto: data.premioBruto === '' ? 0 : data.premioBruto,
        iof: data.iof === '' ? 0 : data.iof,
        comissaoVendedor: data.comissaoVendedor == null ? 0 : data.comissaoVendedor,
        comissaoCorretora: data.comissaoCorretora == null ? 0 : data.comissaoCorretora,
        gerarParcelasAutomaticamente: data.gerarParcelasAutomaticamente,
        ci: data.ci, // Garante que o CI seja enviado
      });
      
      if (data.gerarParcelasAutomaticamente) {
        setSuccess('Apólice atualizada e parcelas geradas com sucesso!');
        // Refresh da página após gerar parcelas
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        setSuccess('Apólice atualizada com sucesso!');
        // Refresh da página após salvar
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
      }
      
    } catch (err) {
      setError('Erro ao atualizar apólice');
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  const formatarData = (data: string) => {
    if (!data) {
      return '-';
    }
    // Adicionar timeZone: 'UTC' para evitar que a data seja alterada pelo fuso horário do navegador.
    return new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  const getStatusPagamentoColor = (status: string) => {
    switch (status) {
      case 'Pago':
        return 'success';
      case 'Atrasado':
        return 'error';
      case 'Pendente':
        return 'warning';
      default:
        return 'default';
    }
  };

  if (loading) {
    return (
      <MainLayout>
        <Container maxWidth="lg">
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
            <CircularProgress />
          </Box>
        </Container>
      </MainLayout>
    );
  }

  if (!apolice) {
    return (
      <MainLayout>
        <Container maxWidth="lg">
          <Alert severity="error">Apólice não encontrada</Alert>
        </Container>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <Container maxWidth="lg">
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" mb={3}>
            <IconButton onClick={() => navigate('/apolices')} sx={{ mr: 2 }}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h4" component="h1">
              Editar Apólice
            </Typography>
          </Box>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

          <Paper sx={{ p: 1 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
                <Tab label="Dados Gerais" />
                <Tab label="Objetos" />
                <Tab label="Objetos RE" />
                <Tab label="Prêmios, Valores e Comissões" />
                    {hasPermission({ entidade: 'pagamentos',  acao: 'can_read'}) && (
                <Tab label="Pagamentos" />
              )}

              {hasPermission({ entidade: 'comissao',  acao: 'can_read' }) && (
                <Tab label="Comissionamento" />
              )}

              {hasPermission({ entidade: 'corretagem', acao: 'can_read' }) && (
                <Tab label="Corretagem" />
              )}
                        
             

                  
                
             
              </Tabs>
            </Box>

            <form onSubmit={handleSubmitApolice(onFormSubmit)}>
              {/* Aba: Dados Gerais */}
              <TabPanel value={tabValue} index={0}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" sx={{ mb: 2, mt: 2 }}>Dados Gerais</Typography>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="cliente.id"
                      control={control}
                      rules={{ required: 'Cliente é obrigatório', min: { value: 1, message: 'Cliente é obrigatório' } }}
                      render={({ field }) => (
                        <FormControl fullWidth error={!!errors.cliente}>
                      <InputLabel>Cliente *</InputLabel>
                      <Select
                            {...field}
                            value={field.value || 0}
                        label="Cliente *"
                      >
                        <MenuItem value={0}>Selecione um cliente</MenuItem>
                        {clientes.map((cliente) => (
                          <MenuItem key={cliente.id} value={cliente.id}>
                            {cliente.nome.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="seguradora.id"
                      control={control}
                      rules={{ required: 'Seguradora é obrigatória', min: { value: 1, message: 'Seguradora é obrigatória' } }}
                      render={({ field }) => (
                        <FormControl fullWidth error={!!errors.seguradora}>
                      <InputLabel>Seguradora *</InputLabel>
                      <Select
                            {...field}
                            value={field.value || 0}
                        label="Seguradora *"
                      >
                        <MenuItem value={0}>Selecione uma seguradora</MenuItem>
                        {seguradoras.map((seguradora) => (
                          <MenuItem key={seguradora.id} value={seguradora.id}>
                            {seguradora.nome.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="ramo.id"
                      control={control}
                      rules={{ required: 'Ramo é obrigatório', min: { value: 1, message: 'Ramo é obrigatório' } }}
                      render={({ field }) => (
                        <FormControl fullWidth error={!!errors.ramo}>
                      <InputLabel>Ramo da Apólice *</InputLabel>
                      <Select
                            {...field}
                            value={field.value || 0}
                        label="Ramo da Apólice *"
                      >
                        <MenuItem value={0}>Selecione um ramo</MenuItem>
                        {ramos.map((ramo) => (
                          <MenuItem key={ramo.id} value={ramo.id}>
                            {ramo.nome.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="vendedor.id"
                      control={control}
                      rules={{ required: 'Vendedor é obrigatório', min: { value: 1, message: 'Vendedor é obrigatório' } }}
                      render={({ field }) => (
                        <FormControl fullWidth error={!!errors.vendedor}>
                      <InputLabel>Vendedor *</InputLabel>
                      <Select
                            {...field}
                            value={field.value || 0}
                        label="Vendedor *"
                        disabled={loadingColaboradores}
                      >
                        <MenuItem value={0}>Selecione um vendedor</MenuItem>
                        {colaboradores.map((colab) => (
                          <MenuItem key={colab.id} value={colab.id}>
                            {colab.nome.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="corretora.id"
                      control={control}
                      rules={{ required: 'Corretora é obrigatória', min: { value: 1, message: 'Corretora é obrigatória' } }}
                      render={({ field }) => (
                        <FormControl fullWidth error={!!errors.corretora}>
                      <InputLabel>Corretora *</InputLabel>
                      <Select
                            {...field}
                            value={field.value || 0}
                        label="Corretora *"
                        disabled={loadingEmpresas}
                      >
                        <MenuItem value={0}>Selecione uma corretora</MenuItem>
                        {empresas.map((empresa) => (
                          <MenuItem key={empresa.id} value={empresa.id}>
                            {empresa.nome.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      label="Número da Apólice"
                      {...register('numero')}
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => { e.target.value = e.target.value.toUpperCase(); }}
                      error={!!errors.numero}
                      helperText={errors.numero?.message}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      label="Produto"
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => { e.target.value = e.target.value.toUpperCase(); }}
                      {...register('produto')}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="status"
                      control={control}
                      rules={{ required: 'Status é obrigatório' }}
                      render={({ field }) => (
                        <FormControl fullWidth error={!!errors.status}>
                      <InputLabel>Status *</InputLabel>
                      <Select
                            {...field}
                        label="Status *"
                      >
                        <MenuItem value="Ativa">Ativa</MenuItem>
                        <MenuItem value="Cancelada">Cancelada</MenuItem>
                        <MenuItem value="Vencida">Vencida</MenuItem>
                        <MenuItem value="Renovação">Renovação</MenuItem>
                      </Select>
                    </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      label="Proposta"
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => { e.target.value = e.target.value.toUpperCase(); }}
                      {...register('proposta')}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      type="date"
                      label="Data de Emissão"
                      {...register('dataEmissao')}
                      error={!!errors.dataEmissao}
                      helperText={errors.dataEmissao?.message}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="seguradoraAnterior.id"
                      control={control}
                      render={({ field }) => (
                        <FormControl fullWidth>
                      <InputLabel>Seguradora Anterior</InputLabel>
                      <Select
                            {...field}
                            value={field.value || 0}
                        label="Seguradora Anterior"
                      >
                        <MenuItem value={0}>Selecione uma seguradora</MenuItem>
                        {seguradoras.map((seguradora) => (
                          <MenuItem key={seguradora.id} value={seguradora.id}>
                            {seguradora.nome.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      label="Apólice Anterior"
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => { e.target.value = e.target.value.toUpperCase(); }}
                      {...register('apoliceAnterior')}
                    />
                  </Grid>

                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    fullWidth
                    label="CI (Opcional)"
                    type="text"
                    {...register('ci', {
                      setValueAs: (v) => (v?.trim() === '' ? null : v),
                    })}
                  />
                </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="formaPagamento"
                      control={control}
                      rules={{ required: 'Forma de pagamento é obrigatória' }}
                      render={({ field }) => (
                        <FormControl fullWidth error={!!errors.formaPagamento}>
                      <InputLabel>Forma de Pagamento *</InputLabel>
                      <Select
                            {...field}
                            value={field.value || ''}
                        label="Forma de Pagamento *"
                      >
                        <MenuItem value="">Selecione uma forma de pagamento</MenuItem>
                        <MenuItem value="CRÉDITO">CRÉDITO</MenuItem>
                        <MenuItem value="DÉBITO">DÉBITO</MenuItem>
                        <MenuItem value="PIX">PIX</MenuItem>
                        <MenuItem value="BOLETO">BOLETO</MenuItem>
                      </Select>
                    </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <FormControl fullWidth>
                      <InputLabel>Proposta Assinada</InputLabel>
                      <Controller
                        name="propostaAssinada"
                        control={control}
                        render={({ field }) => (
                          <Select {...field} value={field.value ? 'true' : 'false'} label="Proposta Assinada" onChange={(e) => field.onChange(e.target.value === 'true')}>
                            <MenuItem value="true">Sim</MenuItem>
                            <MenuItem value="false">Não</MenuItem>
                          </Select>
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <FormControl fullWidth>
                      <InputLabel>Apólice Conferida</InputLabel>
                      <Controller
                        name="apoliceConferida"
                        control={control}
                        render={({ field }) => (
                          <Select {...field} value={field.value ? 'true' : 'false'} label="Apólice Conferida" onChange={(e) => field.onChange(e.target.value === 'true')}>
                            <MenuItem value="true">Sim</MenuItem>
                            <MenuItem value="false">Não</MenuItem>
                          </Select>
                        )}
                      />
                    </FormControl>
                  </Grid>

                  {/* Datas de Vigência */}
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" sx={{ mb: 2, mt: 2 }}>Datas de Vigência</Typography>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      type="date"
                      label="Data de Início *"
                      {...register('dataInicio', { required: 'Data de início é obrigatória' })}
                      error={!!errors.dataInicio}
                      helperText={errors.dataInicio?.message}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      type="date"
                      label="Data de Fim *"
                      {...register('dataFim', { required: 'Data de fim é obrigatória' })}
                      error={!!errors.dataFim}
                      helperText={errors.dataFim?.message}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 2 }}>
                      <Typography variant="h6">Objetos Segurados</Typography>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleOpenAddObjeto}
                      >
                        Adicionar Objeto
                      </Button>
                    </Box>
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="tabela de objetos segurados">
                        <TableHead>
                          <TableRow sx={{ '& th': { fontWeight: 'bold' } }}>
                            <TableCell>Placa</TableCell>
                            <TableCell>Chassi</TableCell>
                            <TableCell>Modelo</TableCell>
                            <TableCell>Ano do Modelo</TableCell>
                            <TableCell align="center">Ações</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {loadingObjetos ? (
                            <TableRow>
                              <TableCell colSpan={5} align="center"><CircularProgress size={24} /></TableCell>
                            </TableRow>
                          ) : objetosSegurados.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={5} align="center">Nenhum objeto segurado encontrado.</TableCell>
                            </TableRow>
                          ) : (
                            objetosSegurados.map((veiculo) => (
                              <TableRow hover key={veiculo.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell>{veiculo.placa}</TableCell>
                                <TableCell>{veiculo.chassi}</TableCell>
                                <TableCell>{veiculo.modelo}</TableCell>
                                <TableCell>{veiculo.ano_modelo}</TableCell>
                                <TableCell align="center">
                                  <IconButton size="small" color="primary" title="Editar" onClick={() => handleOpenEditObjeto(veiculo)}>
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton size="small" color="error" title="Excluir" onClick={() => handleOpenDeleteObjeto(veiculo)}>
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Aba: Objetos RE */}
              <TabPanel value={tabValue} index={2}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 2 }}>
                      <Typography variant="h6">Objetos de RE</Typography>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleOpenObjetoREDialog}
                      >
                        Adicionar Objeto RE
                      </Button>
                    </Box>
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    {loadingObjetosRE ? (
                      <CircularProgress />
                    ) : objetosRE.length === 0 ? (
                      <Alert severity="info">Nenhum objeto de resseguro cadastrado para esta apólice.</Alert>
                    ) : (
                      objetosRE.map(objeto => (
                        <Paper key={objeto.id} sx={{ p: 2, mb: 2 }} variant="outlined">
                          <Typography variant="subtitle1" fontWeight="bold">{objeto.descricao}</Typography>
                          <TableContainer>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Cobertura</TableCell>
                                  <TableCell align="right">Valor (R$)</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {objeto.coberturas.map(cob => (
                                  <TableRow key={cob.id}>
                                    <TableCell>{cob.cobertura.nome}</TableCell>
                                    <TableCell align="right">{formatarMoeda(parseFloat(cob.valor))}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <IconButton 
                              size="small" 
                              color="error" 
                              onClick={() => handleOpenDeleteObjetoRE(objeto)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </Paper>
                      ))
                    )}
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Aba: Prêmios, Valores e Comissões */}
              <TabPanel value={tabValue} index={3}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" sx={{ mb: 2, mt: 2 }}>Prêmios e Valores</Typography>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="premioBruto"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <NumericFormat
                          value={field.value ?? ''}
                          thousandSeparator="."
                          decimalSeparator=","
                          allowNegative={false}
                          decimalScale={2}
                          fixedDecimalScale
                          customInput={TextField}
                          fullWidth
                          label="Prêmio Bruto"
                          placeholder="0,00"

                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">R$</InputAdornment>
                            ),
                          }}

                          // 🔑 só entra FLOAT no form
                          onValueChange={(values) => {
                            field.onChange(values.floatValue ?? null);
                          }}

                          // 🚫 bloqueia string
                          onChange={() => {}}
                          onBlur={field.onBlur}
                        />
                      )}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="iof"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <NumericFormat
                          value={field.value ?? ''}
                          thousandSeparator="."
                          decimalSeparator=","
                          allowNegative={false}
                          decimalScale={2}
                          fixedDecimalScale
                          customInput={TextField}
                          fullWidth
                          label="IOF"
                          placeholder="0,00"

                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">R$</InputAdornment>
                            ),
                          }}

                          // 🔑 só entra FLOAT no form
                          onValueChange={(values) => {
                            field.onChange(values.floatValue ?? null);
                          }}

                          // 🚫 bloqueia string
                          onChange={() => {}}
                          onBlur={field.onBlur}
                        />
                      )}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      label="Quantidade de Parcelas"
                      type="number"
                      {...register('quantidadeParcelas', { valueAsNumber: true, min: 1 })}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      label="Prêmio Líquido"
                      type="number"
                      value={(() => {
                        const watchedValues = watch(['premioBruto', 'iof']);
                        const premioBruto = parseFloat(watchedValues[0] as string) || 0;
                        const iof = parseFloat(watchedValues[1] as string) || 0;

                        const premioLiquido = premioBruto - iof;

                        return premioLiquido > 0 ? premioLiquido.toFixed(2) : '';
                      })()}
                      placeholder="0,00"
                      InputProps={{
                        startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                        readOnly: true,
                      }}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      type="date"
                      label="Data do 1º Vencimento"
                      {...register('dataPrimeiroPagamento')}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      type="date"
                      label="Data do 2º Vencimento"
                      {...register('dataSegundoPagamento')}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  {/* Seção de Comissões */}
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" sx={{ mb: 2, mt: 4 }}>Comissões</Typography>
                  </Grid>
                     <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="comissaoVendedor"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <NumericFormat
                          value={field.value ?? ''}
                          thousandSeparator="."
                          decimalSeparator=","
                          allowNegative={false}
                          decimalScale={2}
                          fixedDecimalScale
                          customInput={TextField}
                          fullWidth
                          label="Comissão do Vendedor (%)"
                          placeholder="0,00"

                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">%</InputAdornment>
                            ),
                          }}

                          // 🔑 só entra FLOAT no form
                          onValueChange={(values) => {
                            field.onChange(values.floatValue ?? null);
                          }}

                          // 🚫 bloqueia string
                          onChange={() => {}}
                          onBlur={field.onBlur}
                        />
                      )}
                    />
                  </Grid>
                     <Grid size={{ xs: 12, sm: 6 }}>
                    <Controller
                      name="comissaoCorretora"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <NumericFormat
                          value={field.value ?? ''}
                          thousandSeparator="."
                          decimalSeparator=","
                          allowNegative={false}
                          decimalScale={2}
                          fixedDecimalScale
                          customInput={TextField}
                          fullWidth
                          label="Comissão da Corretora (%)"
                          placeholder="0,00"

                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">%</InputAdornment>
                            ),
                          }}

                          // 🔑 só entra FLOAT no form
                          onValueChange={(values) => {
                            field.onChange(values.floatValue ?? null);
                          }}

                          // 🚫 bloqueia string
                          onChange={() => {}}
                          onBlur={field.onBlur}
                        />
                      )}
                    />
                  </Grid>
                


                  {/* Opções de Geração Automática - Final do Formulário */}
                  <Grid size={{ xs: 12 }}>
                    <Paper sx={{ p: 2, mt: 3, backgroundColor: '#f5f5f5' }}>
                      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                        Geração de Parcelas
                      </Typography>
                      <Grid container spacing={2} alignItems="center">
                        <Grid size={{ xs: 12, sm: 6 }}>
                          <FormControlLabel
                            control={<Checkbox {...register('gerarParcelasAutomaticamente')} />}
                            label="Gerar parcelas automaticamente ao salvar"
                          />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                          {watch('gerarParcelasAutomaticamente') && (
                            <Alert severity="info" sx={{ fontSize: '0.875rem' }}>
                              As parcelas serão geradas baseadas no prêmio bruto e quantidade de parcelas definidos acima
                            </Alert>
                          )}
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Aba: Pagamentos */}
              <TabPanel value={tabValue} index={4}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 2 }}>
                      <Typography variant="h6">Pagamentos</Typography>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                          variant="outlined"
                          onClick={handleGerarParcelas}
                          disabled={pagamentos.length > 0}
                        >
                          {pagamentos.length > 0 ? 'Regenerar Parcelas' : 'Gerar Parcelas'}
                        </Button>
                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={handleAbrirCreatePagamento}
                        >
                          Novo Pagamento
                        </Button>
                      </Box>
                    </Box>
                  </Grid>


                  {/* Tabela de Pagamentos */}
                  <Grid size={{ xs: 12 }}>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Parcela</TableCell>
                            <TableCell>Valor</TableCell>
                            <TableCell>Vencimento</TableCell>
                            <TableCell>Pagamento</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Forma Pagamento</TableCell>
                            <TableCell align="center">Ações</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {loadingPagamentos ? (
                            <TableRow>
                              <TableCell colSpan={7} align="center">
                                <CircularProgress size={24} />
                              </TableCell>
                            </TableRow>
                          ) : (
                            pagamentos.map((pagamento) => (
                              <TableRow key={pagamento.id}>
                                <TableCell>{pagamento.numeroParcela}</TableCell>
                                <TableCell>{formatarMoeda(pagamento.valorParcela)}</TableCell>
                                <TableCell>{formatarData(pagamento.dataVencimento)}</TableCell>
                                <TableCell>{pagamento.dataPagamento ? formatarData(pagamento.dataPagamento) : '-'}</TableCell>
                                <TableCell>
                                  <Chip label={pagamento.status} color={getStatusPagamentoColor(pagamento.status)} />
                                </TableCell>
                                <TableCell>{pagamento.formaPagamento || '-'}</TableCell>
                                <TableCell align="center">
                                  <IconButton onClick={() => handleEditarPagamento(pagamento)} size="small">
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton onClick={() => handleExcluirPagamento(pagamento.id)} size="small" color="error">
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Adicionar TabPanel para comissionamento */}
              <TabPanel value={tabValue} index={5}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                  <Tabs value={tabValueComissao} onChange={handleTabChangeComissao} aria-label="comissionamento tabs">
                    <Tab label="Colaborador" />
                    <Tab label="Corretora" />
                  </Tabs>
                </Box>

                {/* Sub-aba: Comissões do Colaborador */}
                <TabPanel value={tabValueComissao} index={0}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 2 }}>
                        <Typography variant="h6">Parcelas de Comissão do Colaborador</Typography>
                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={() => handleOpenBulkComissao('colaborador')}>
                          Criar Parcelas em Lote
                        </Button>
                      </Box>
                    </Grid>
                  <Grid size={{ xs: 12 }}>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Parcela</TableCell>
                            <TableCell>Valor</TableCell>
                            <TableCell>Data Prevista</TableCell>
                            <TableCell>Data Pagamento</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Ações</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {loadingComissoes ? (
                            <TableRow>
                              <TableCell colSpan={4} align="center">
                                <CircularProgress size={24} />
                              </TableCell>
                            </TableRow>
                          ) : (
                            comissoesColaborador.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={6} align="center">Nenhuma comissão gerada</TableCell>
                              </TableRow>
                            ) : (
                              comissoesColaborador.map((comissao) => (
                                <TableRow key={comissao.id}>
                                  <TableCell>{comissao.numeroParcela}</TableCell>
                                  <TableCell>{formatarMoeda(comissao.valor)}</TableCell>
                                  <TableCell>{comissao.dataPrevista ? formatarData(comissao.dataPrevista) : '-'}</TableCell>
                                  <TableCell>{comissao.dataPagamento ? formatarData(comissao.dataPagamento) : '-'}</TableCell>
                                  <TableCell>
                                    <Chip 
                                      label={comissao.status} 
                                      color={comissao.status === 'Pago' ? 'success' : 'warning'}
                                      size="small"
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleEditarComissao(comissao)}
                                      color="primary"
                                    >
                                      <EditIcon />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleExcluirComissao(comissao.id)}
                                      color="error"
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))
                            )
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Sub-aba: Comissões da Corretora */}
              <TabPanel value={tabValueComissao} index={1}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 2 }}>
                      <Typography variant="h6">Parcelas de Comissão da Corretora</Typography>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => handleOpenBulkComissao('corretora')}>
                        Criar Parcelas em Lote
                      </Button>
                    </Box>
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Parcela</TableCell>
                            <TableCell>Valor</TableCell>
                            <TableCell>Data Prevista</TableCell>
                            <TableCell>Data Pagamento</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Ações</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {loadingComissoesCorretora ? (
                            <TableRow>
                              <TableCell colSpan={4} align="center">
                                <CircularProgress size={24} />
                              </TableCell>
                            </TableRow>
                          ) : (
                            comissoesCorretora.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={6} align="center">Nenhuma comissão gerada</TableCell>
                              </TableRow>
                            ) : (
                              comissoesCorretora.map((comissao) => (
                                <TableRow key={comissao.id}>
                                  <TableCell>{comissao.numeroParcela}</TableCell>
                                  <TableCell>{formatarMoeda(comissao.valor)}</TableCell>
                                  <TableCell>{comissao.dataPrevista ? formatarData(comissao.dataPrevista) : '-'}</TableCell>
                                  <TableCell>{comissao.dataPagamento ? formatarData(comissao.dataPagamento) : '-'}</TableCell>
                                  <TableCell>
                                    <Chip 
                                      label={comissao.status} 
                                      color={comissao.status === 'Pago' ? 'success' : 'warning'}
                                      size="small"
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleEditarComissaoCorretora(comissao)}
                                      color="primary"
                                    >
                                      <EditIcon />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleExcluirComissaoCorretora(comissao.id)}
                                      color="error"
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))
                            )
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </TabPanel>
              </TabPanel>

              {/* Aba: Corretagem */}
              <TabPanel value={tabValue} index={6}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" sx={{ mb: 2, mt: 2 }}>Pagamentos de Corretagem</Typography>
                  </Grid>
                  


                  {/* Botões de Ação */}
                  <Grid size={{ xs: 12 }}>
                    <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => setOpenCriarParcelas(true)}
                      >
                        Criar Parcelas
                      </Button>
                      {selectedPagamentosCorretagem.length > 0 && (
                        <Button
                          variant="outlined"
                          color="error"
                          startIcon={<DeleteIcon />}
                          onClick={() => setOpenDeleteConfirm(true)}
                        >
                          Excluir Selecionadas ({selectedPagamentosCorretagem.length})
                        </Button>
                      )}
                    </Box>
                  </Grid>

                  {/* Tabela de Pagamentos */}
                  <Grid size={{ xs: 12 }}>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell padding="checkbox">
                              <Checkbox
                                color="primary"
                                indeterminate={selectedPagamentosCorretagem.length > 0 && selectedPagamentosCorretagem.length < pagamentosCorretagem.length}
                                checked={pagamentosCorretagem.length > 0 && selectedPagamentosCorretagem.length === pagamentosCorretagem.length}
                                onChange={handleSelectAllPagamentosCorretagem}
                                inputProps={{
                                  'aria-label': 'select all payments',
                                }}
                              />
                            </TableCell>
                            <TableCell>Parcela</TableCell>
                            <TableCell>Valor</TableCell>
                            <TableCell>Data Vencimento</TableCell>
                            <TableCell>Data Pagamento</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Ações</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {loadingPagamentosCorretagem ? (
                            <TableRow>
                              <TableCell colSpan={7} align="center">
                                <CircularProgress size={24} />
                              </TableCell>
                            </TableRow>
                          ) : (
                            pagamentosCorretagem.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={6} align="center">Nenhum pagamento de corretagem encontrado</TableCell>
                              </TableRow>
                            ) : (pagamentosCorretagem.map((pagamento) => {
                                const isSelected = isPagamentoCorretagemSelected(pagamento.id);
                                return (
                                  <TableRow key={pagamento.id} hover selected={isSelected}>
                                    <TableCell padding="checkbox">
                                      <Checkbox
                                        color="primary"
                                        checked={isSelected}
                                        onChange={() => handleSelectOnePagamentoCorretagem(pagamento.id)}
                                      />
                                    </TableCell>
                                    <TableCell>{pagamento.numeroParcela}</TableCell>
                                    <TableCell>{formatarMoeda(pagamento.valorParcela)}</TableCell>
                                    <TableCell>{formatarData(pagamento.dataVencimento)}</TableCell>
                                    <TableCell>{pagamento.dataPagamento ? formatarData(pagamento.dataPagamento) : '-'}</TableCell>
                                    <TableCell>
                                      <Chip
                                        label={pagamento.status}
                                        color={
                                          pagamento.status === 'Pago' ? 'success' :
                                            pagamento.status === 'Atrasado' ? 'error' :
                                              pagamento.status === 'Cancelado' ? 'default' : 'warning'
                                        }
                                        size="small"
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <IconButton size="small" onClick={() => handleEditarPagamentoCorretagem(pagamento)} color="primary">
                                        <EditIcon />
                                      </IconButton>
                                      <IconButton size="small" onClick={() => handleExcluirPagamentoCorretagem(pagamento.id)} color="error">
                                        <DeleteIcon />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                );
                              }))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Botões de ação */}
              <Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/apolices')}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={saving}
                >
                  {saving ? <CircularProgress size={20} /> : 'Salvar Alterações'}
                </Button>
              </Box>
            </form>
          </Paper>
        </Box>

        {/* Dialog de Edição de Pagamento */}
        <Dialog open={openEditPagamento} onClose={handleFecharEditPagamento} maxWidth="md" fullWidth>
          <DialogTitle>
            Editar Pagamento - Parcela {pagamentoEditando?.numeroParcela}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Número da Parcela"
                  type="number"
                  value={editPagamentoForm.numeroParcela}
                  onChange={(e) => setEditPagamentoForm({ ...editPagamentoForm, numeroParcela: parseInt(e.target.value) || 1 })}
                />
              </Grid>
                              <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    fullWidth
                    label="Valor da Parcela"
                    type="number"
                    value={editPagamentoForm.valorParcela === 0 ? '' : editPagamentoForm.valorParcela}
                    onChange={(e) => setEditPagamentoForm({ ...editPagamentoForm, valorParcela: e.target.value === '' ? 0 : parseFloat(e.target.value) || 0 })}
                    placeholder="0,00"
                    InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
                  />
                </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de Vencimento"
                  value={editPagamentoForm.dataVencimento}
                  onChange={(e) => setEditPagamentoForm({ ...editPagamentoForm, dataVencimento: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de Pagamento"
                  value={editPagamentoForm.dataPagamento}
                  onChange={(e) => setEditPagamentoForm({ ...editPagamentoForm, dataPagamento: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={editPagamentoForm.status}
                    label="Status"
                    onChange={(e) => setEditPagamentoForm({ ...editPagamentoForm, status: e.target.value as 'Pendente' | 'Pago' | 'Atrasado' })}
                  >
                    <MenuItem value="Pendente">Pendente</MenuItem>
                    <MenuItem value="Pago">Pago</MenuItem>
                    <MenuItem value="Atrasado">Atrasado</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth>
                  <InputLabel>Forma de Pagamento</InputLabel>
                  <Select
                    value={editPagamentoForm.formaPagamento || ''}
                    label="Forma de Pagamento"
                    onChange={(e) => setEditPagamentoForm({ ...editPagamentoForm, formaPagamento: e.target.value as 'CRÉDITO' | 'DÉBITO' | 'PIX' | 'BOLETO' })}
                  >
                    <MenuItem value="">Selecione uma forma de pagamento</MenuItem>
                    <MenuItem value="CRÉDITO">CRÉDITO</MenuItem>
                    <MenuItem value="DÉBITO">DÉBITO</MenuItem>
                    <MenuItem value="PIX">PIX</MenuItem>
                    <MenuItem value="BOLETO">BOLETO</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Observação"
                  value={editPagamentoForm.observacao}
                  onChange={(e) => setEditPagamentoForm({ ...editPagamentoForm, observacao: e.target.value })}
                  multiline
                  rows={3}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleFecharEditPagamento}>Cancelar</Button>
            <Button onClick={handleSalvarEditPagamento} variant="contained">
              Salvar Alterações
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Criação de Pagamento */}
        <Dialog open={openCreatePagamento} onClose={handleFecharCreatePagamento} maxWidth="md" fullWidth>
          <DialogTitle>
            Novo Pagamento
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Número da Parcela"
                  type="number"
                  value={pagamentoForm.numeroParcela}
                  onChange={(e) => setPagamentoForm({ ...pagamentoForm, numeroParcela: parseInt(e.target.value) || 1 })}
                />
              </Grid>
                              <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    fullWidth
                    label="Valor da Parcela"
                    type="number"
                    value={pagamentoForm.valorParcela === 0 ? '' : pagamentoForm.valorParcela}
                    onChange={(e) => setPagamentoForm({ ...pagamentoForm, valorParcela: e.target.value === '' ? 0 : parseFloat(e.target.value) || 0 })}
                    placeholder="0,00"
                    InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
                  />
                </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de Vencimento"
                  value={pagamentoForm.dataVencimento}
                  onChange={(e) => setPagamentoForm({ ...pagamentoForm, dataVencimento: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de Pagamento"
                  value={pagamentoForm.dataPagamento}
                  onChange={(e) => setPagamentoForm({ ...pagamentoForm, dataPagamento: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={pagamentoForm.status}
                    label="Status"
                    onChange={(e) => setPagamentoForm({ ...pagamentoForm, status: e.target.value as 'Pendente' | 'Pago' | 'Atrasado' })}
                  >
                    <MenuItem value="Pendente">Pendente</MenuItem>
                    <MenuItem value="Pago">Pago</MenuItem>
                    <MenuItem value="Atrasado">Atrasado</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth>
                  <InputLabel>Forma de Pagamento</InputLabel>
                  <Select
                    value={pagamentoForm.formaPagamento || ''}
                    label="Forma de Pagamento"
                    onChange={(e) => setPagamentoForm({ ...pagamentoForm, formaPagamento: e.target.value as 'CRÉDITO' | 'DÉBITO' | 'PIX' | 'BOLETO' })}
                  >
                    <MenuItem value="">Selecione uma forma de pagamento</MenuItem>
                    <MenuItem value="CRÉDITO">CRÉDITO</MenuItem>
                    <MenuItem value="DÉBITO">DÉBITO</MenuItem>
                    <MenuItem value="PIX">PIX</MenuItem>
                    <MenuItem value="BOLETO">BOLETO</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Observação"
                  value={pagamentoForm.observacao}
                  onChange={(e) => setPagamentoForm({ ...pagamentoForm, observacao: e.target.value })}
                  multiline
                  rows={3}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleFecharCreatePagamento}>Cancelar</Button>
            <Button onClick={handleCriarPagamento} variant="contained">
              Criar Pagamento
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Edição de Comissão */}
        <Dialog open={openEditComissao} onClose={handleFecharEditComissao} maxWidth="md" fullWidth>
          <DialogTitle>
            Editar Comissão - Parcela {comissaoEditando?.numeroParcela}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Valor da Comissão"
                  type="number"
                  value={editComissaoForm.valor}
                  onChange={(e) => setEditComissaoForm({ ...editComissaoForm, valor: parseFloat(e.target.value) || 0 })}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data Prevista"
                  value={editComissaoForm.dataPrevista}
                  onChange={(e) => setEditComissaoForm({ ...editComissaoForm, dataPrevista: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de Pagamento"
                  value={editComissaoForm.dataPagamento}
                  onChange={(e) => setEditComissaoForm({ ...editComissaoForm, dataPagamento: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={editComissaoForm.status}
                    label="Status"
                    onChange={(e) => setEditComissaoForm({ ...editComissaoForm, status: e.target.value as 'Pendente' | 'Pago' })}
                  >
                    <MenuItem value="Pendente">Pendente</MenuItem>
                    <MenuItem value="Pago">Pago</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleFecharEditComissao}>Cancelar</Button>
            <Button onClick={handleSalvarEditComissao} variant="contained">
              Salvar Alterações
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Edição de Comissão da Corretora */}
        <Dialog open={openEditComissaoCorretora} onClose={handleFecharEditComissaoCorretora} maxWidth="md" fullWidth>
          <DialogTitle>
            Editar Comissão da Corretora - Parcela {comissaoCorretoraEditando?.numeroParcela}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Valor da Comissão"
                  type="number"
                  value={editComissaoCorretoraForm.valor}
                  onChange={(e) => setEditComissaoCorretoraForm({ ...editComissaoCorretoraForm, valor: parseFloat(e.target.value) || 0 })}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data Prevista"
                  value={editComissaoCorretoraForm.dataPrevista}
                  onChange={(e) => setEditComissaoCorretoraForm({ ...editComissaoCorretoraForm, dataPrevista: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de Pagamento"
                  value={editComissaoCorretoraForm.dataPagamento}
                  onChange={(e) => setEditComissaoCorretoraForm({ ...editComissaoCorretoraForm, dataPagamento: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={editComissaoCorretoraForm.status}
                    label="Status"
                    onChange={(e) => setEditComissaoCorretoraForm({ ...editComissaoCorretoraForm, status: e.target.value as 'Pendente' | 'Pago' })}
                  >
                    <MenuItem value="Pendente">Pendente</MenuItem>
                    <MenuItem value="Pago">Pago</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleFecharEditComissaoCorretora}>Cancelar</Button>
            <Button onClick={handleSalvarEditComissaoCorretora} variant="contained">
              Salvar Alterações
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Criação de Parcelas de Corretagem */}
        <Dialog open={openCriarParcelas} onClose={() => {
          setOpenCriarParcelas(false);
          limparFormularioCriarParcelas();
        }} maxWidth="md" fullWidth>
          <DialogTitle>Criar Parcelas de Corretagem</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Quantidade de Parcelas"
                  type="number"
                  value={criarParcelasForm.quantidadeParcelas}
                  onChange={(e) => setCriarParcelasForm({ ...criarParcelasForm, quantidadeParcelas: parseInt(e.target.value) || 1 })}
                  InputProps={{ inputProps: { min: 1 } }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Valor da Parcela"
                  type="number"
                  value={criarParcelasForm.valorParcela === 0 ? '' : criarParcelasForm.valorParcela}
                  onChange={(e) => setCriarParcelasForm({ ...criarParcelasForm, valorParcela: e.target.value === '' ? 0 : parseFloat(e.target.value) || 0 })}
                  placeholder="0,00"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de Início (opcional)"
                  value={criarParcelasForm.dataInicio}
                  onChange={(e) => setCriarParcelasForm({ ...criarParcelasForm, dataInicio: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  helperText="Deixe em branco para usar a data de início da apólice"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              setOpenCriarParcelas(false);
              limparFormularioCriarParcelas();
            }}>Cancelar</Button>
            <Button onClick={handleCriarParcelas} variant="contained">
              Criar Parcelas
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Criação de Comissão em Lote */}
        <Dialog open={openBulkComissao} onClose={handleCloseBulkComissao} maxWidth="sm" fullWidth>
          <DialogTitle>
            Criar Parcelas de Comissão em Lote ({bulkComissaoType === 'colaborador' ? 'Colaborador' : 'Corretora'})
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Quantidade de Parcelas"
                  type="number"
                  value={bulkComissaoForm.quantidadeParcelas}
                  onChange={(e) => setBulkComissaoForm({ ...bulkComissaoForm, quantidadeParcelas: parseInt(e.target.value) || 1 })}
                  InputProps={{ inputProps: { min: 1 } }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Valor por Parcela"
                  type="number"
                  value={bulkComissaoForm.valorParcela === 0 ? '' : bulkComissaoForm.valorParcela}
                  onChange={(e) => setBulkComissaoForm({ ...bulkComissaoForm, valorParcela: e.target.value === '' ? 0 : parseFloat(e.target.value) || 0 })}
                  placeholder="0,00"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de Início da 1ª Parcela (Opcional)"
                  value={bulkComissaoForm.dataInicio}
                  onChange={(e) => setBulkComissaoForm({ ...bulkComissaoForm, dataInicio: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  helperText="Se deixado em branco, será usada a data de início da apólice."
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseBulkComissao}>Cancelar</Button>
            <Button onClick={handleCreateBulkComissao} variant="contained" disabled={bulkComissaoSaving}>
              {bulkComissaoSaving ? <CircularProgress size={24} /> : 'Criar Parcelas'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Edição de Pagamento de Corretagem */}
        <Dialog open={openEditPagamentoCorretagem} onClose={handleFecharEditPagamentoCorretagem} maxWidth="md" fullWidth>
          <DialogTitle>
            Editar Pagamento de Corretagem - Parcela {pagamentoCorretagemEditando?.numeroParcela}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Número da Parcela"
                  type="number"
                  value={editPagamentoCorretagemForm.numeroParcela}
                  onChange={(e) => setEditPagamentoCorretagemForm({ ...editPagamentoCorretagemForm, numeroParcela: parseInt(e.target.value) || 1 })}
                  InputProps={{ inputProps: { min: 1 } }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Valor da Parcela"
                  type="number"
                  value={editPagamentoCorretagemForm.valorParcela === 0 ? '' : editPagamentoCorretagemForm.valorParcela}
                  onChange={(e) => {
                    const valorParcela = e.target.value === '' ? 0 : parseFloat(e.target.value) || 0;
                    setEditPagamentoCorretagemForm({ 
                      ...editPagamentoCorretagemForm, 
                      valorParcela
                    });
                  }}
                  placeholder="0,00"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de Vencimento"
                  value={editPagamentoCorretagemForm.dataVencimento}
                  onChange={(e) => setEditPagamentoCorretagemForm({ ...editPagamentoCorretagemForm, dataVencimento: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de Pagamento"
                  value={editPagamentoCorretagemForm.dataPagamento}
                  onChange={(e) => setEditPagamentoCorretagemForm({ ...editPagamentoCorretagemForm, dataPagamento: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={editPagamentoCorretagemForm.status}
                    label="Status"
                    onChange={(e) => setEditPagamentoCorretagemForm({ ...editPagamentoCorretagemForm, status: e.target.value as 'Pendente' | 'Pago' | 'Atrasado' | 'Cancelado' })}
                  >
                    <MenuItem value="Pendente">Pendente</MenuItem>
                    <MenuItem value="Pago">Pago</MenuItem>
                    <MenuItem value="Atrasado">Atrasado</MenuItem>
                    <MenuItem value="Cancelado">Cancelado</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth>
                  <InputLabel>Forma de Pagamento</InputLabel>
                  <Select
                    value={editPagamentoCorretagemForm.formaPagamento || ''}
                    label="Forma de Pagamento"
                    onChange={(e) => setEditPagamentoCorretagemForm({ ...editPagamentoCorretagemForm, formaPagamento: e.target.value as 'CRÉDITO' | 'DÉBITO' | 'PIX' | 'BOLETO' | 'TRANSFERÊNCIA' })}
                  >
                    <MenuItem value="">Selecione</MenuItem>
                    <MenuItem value="CRÉDITO">Crédito</MenuItem>
                    <MenuItem value="DÉBITO">Débito</MenuItem>
                    <MenuItem value="PIX">PIX</MenuItem>
                    <MenuItem value="BOLETO">Boleto</MenuItem>
                    <MenuItem value="TRANSFERÊNCIA">Transferência</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Observação"
                  multiline
                  rows={3}
                  value={editPagamentoCorretagemForm.observacao}
                  onChange={(e) => setEditPagamentoCorretagemForm({ ...editPagamentoCorretagemForm, observacao: e.target.value })}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleFecharEditPagamentoCorretagem}>Cancelar</Button>
            <Button onClick={handleSalvarEditPagamentoCorretagem} variant="contained">
              Salvar Alterações
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Confirmação de Exclusão (Único e Múltiplo) */}
        <Dialog
          open={openDeleteConfirm}
          onClose={() => {
            setOpenDeleteConfirm(false);
            setPagamentoToDelete(null);
          }}
        >
          <DialogTitle>Confirmar Exclusão</DialogTitle>
          <DialogContent>
            <Typography>
              {pagamentoToDelete
                ? 'Tem certeza que deseja excluir esta parcela de corretagem? Esta ação não pode ser desfeita.'
                : `Tem certeza que deseja excluir as ${selectedPagamentosCorretagem.length} parcelas de corretagem selecionadas? Esta ação não pode ser desfeita.`
              }
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              setOpenDeleteConfirm(false);
              setPagamentoToDelete(null);
            }}>
              Cancelar
            </Button>
            <Button onClick={handleConfirmDelete} color="error" variant="contained">
              Excluir
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Adicionar/Editar Objeto Segurado */}
      <Dialog open={openObjetoDialog} onClose={handleCloseObjetoDialog} maxWidth="sm" fullWidth>
  <DialogTitle>{objetoEditando ? 'Editar Objeto Segurado' : 'Adicionar Objeto Segurado'}</DialogTitle>
  <DialogContent>
    <form onSubmit={objetoAsseguradoForm.handleSubmit(handleSaveObjeto)}>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid size={{ xs: 6, sm: 6 }}>
          <TextField
            fullWidth
            label="Placa"
            {...objetoAsseguradoForm.register('placa', { required: true })}
            error={!!objetoAsseguradoForm.formState.errors.placa}
            helperText={objetoAsseguradoForm.formState.errors.placa ? 'Campo obrigatório' : ''}
            inputProps={{ maxLength: 7 }}
          />
        </Grid>

        <Grid size={{ xs: 6 }}>
          <TextField
            fullWidth
            label="Chassi"
            {...objetoAsseguradoForm.register('chassi', { required: true })}
            error={!!objetoAsseguradoForm.formState.errors.chassi}
            helperText={objetoAsseguradoForm.formState.errors.chassi ? 'Campo obrigatório' : ''}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Marca"
            {...objetoAsseguradoForm.register('marca', { required: true })}
            error={!!objetoAsseguradoForm.formState.errors.marca}
            helperText={objetoAsseguradoForm.formState.errors.marca ? 'Campo obrigatório' : ''}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Modelo"
            {...objetoAsseguradoForm.register('modelo', { required: true })}
            error={!!objetoAsseguradoForm.formState.errors.modelo}
            helperText={objetoAsseguradoForm.formState.errors.modelo ? 'Campo obrigatório' : ''}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Ano de Fabricação"
            type="number"
            {...objetoAsseguradoForm.register('ano_fabricacao', {
              required: true,
              validate: (v) => v.toString().length === 4,
            })}
            error={!!objetoAsseguradoForm.formState.errors.ano_fabricacao}
            helperText={objetoAsseguradoForm.formState.errors.ano_fabricacao ? 'Ano inválido' : ''}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Ano do Modelo"
            type="number"
            {...objetoAsseguradoForm.register('ano_modelo', {
              required: true,
              validate: (v) => v.toString().length === 4,
            })}
            error={!!objetoAsseguradoForm.formState.errors.ano_modelo}
            helperText={objetoAsseguradoForm.formState.errors.ano_modelo ? 'Ano inválido' : ''}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Combustível"
            {...objetoAsseguradoForm.register('combustivel')}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Carroceria"
            {...objetoAsseguradoForm.register('carroceria')}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            fullWidth
            label="Lotação Oficial"
            type="number"
            {...objetoAsseguradoForm.register('lotacao_oficial', { valueAsNumber: true })}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            fullWidth
            label="Qtd. Portas"
            type="number"
            {...objetoAsseguradoForm.register('qtd_portas', { valueAsNumber: true })}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            fullWidth
            label="Qtd. Eixos"
            type="number"
            {...objetoAsseguradoForm.register('qtd_eixos', { valueAsNumber: true })}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            label="Valor de Mercado (FIPE)"
            type="number"
            {...objetoAsseguradoForm.register('valor_de_mercado', { valueAsNumber: true })}
            placeholder="0,00"
            InputProps={{
              startAdornment: <InputAdornment position="start">R$</InputAdornment>,
            }}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            label="Outros"
            multiline
            rows={3}
            {...objetoAsseguradoForm.register('outros')}
          />
        </Grid>
      </Grid>

      <DialogActions sx={{ mt: 2 }}>
        <Button onClick={handleCloseObjetoDialog}>Cancelar</Button>
        <Button type="submit" variant="contained" disabled={savingObjeto}>
          {savingObjeto ? <CircularProgress size={24} /> : 'Salvar'}
        </Button>
      </DialogActions>
    </form>
  </DialogContent>
</Dialog>


        {/* Dialog de Confirmação de Exclusão de Objeto Segurado */}
        <Dialog
          open={openDeleteObjetoConfirm}
          onClose={handleCloseDeleteObjeto}
        >
          <DialogTitle>Confirmar Exclusão</DialogTitle>
          <DialogContent>
            <Typography>
              Tem certeza que deseja excluir o objeto de placa <strong>{objetoToDelete?.placa}</strong>?
              Esta ação não pode ser desfeita.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteObjeto}>
              Cancelar
            </Button>
            <Button onClick={handleConfirmDeleteObjeto} color="error" variant="contained">
              Excluir
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Adicionar Objeto de Resseguro (RE) */}
        <Dialog open={openObjetoREDialog} onClose={handleCloseObjetoREDialog} maxWidth="md" fullWidth>
          <DialogTitle>Adicionar Objeto de RE</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Descrição do Objeto RE"
                  value={objetoREForm.descricao}
                  onChange={(e) => handleObjetoREFormChange('descricao', e.target.value)}
                  multiline
                  rows={3}
                  required
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Coberturas e Valores</Typography>
              </Grid>

              {objetoREForm.coberturas.map((cobertura, index) => (
                <React.Fragment key={index}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <FormControl fullWidth>
                      <InputLabel>Cobertura</InputLabel>
                      <Select
                        value={cobertura.coberturaId}
                        label="Cobertura"
                        onChange={(e) => handleCoberturaREChange(index, 'coberturaId', e.target.value)}
                      >
                        <MenuItem value={0}>Selecione...</MenuItem>
                        {coberturasDisponiveis.map(c => (
                          <MenuItem key={c.id} value={c.id}>{c.nome}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 5 }}>
                    <TextField
                      fullWidth
                      label="Valor"
                      type="number"
                      value={cobertura.valor === 0 ? '' : cobertura.valor}
                      onChange={(e) => handleCoberturaREChange(index, 'valor', parseFloat(e.target.value) || 0)}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 2, sm: 1 }} sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton onClick={() => removerCampoCoberturaRE(index)} color="error" disabled={objetoREForm.coberturas.length <= 1}>
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </React.Fragment>
              ))}

              <Grid size={{ xs: 12 }}>
                <Button
                  startIcon={<AddIcon />}
                  onClick={adicionarCampoCoberturaRE}
                  sx={{ mt: 1 }}
                >
                  Adicionar Cobertura
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseObjetoREDialog}>Cancelar</Button>
            <Button onClick={handleSaveObjetoRE} variant="contained" disabled={savingObjetoRE}>
              {savingObjetoRE ? <CircularProgress size={24} /> : 'Salvar Objeto RE'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Confirmação de Exclusão de Objeto RE */}
        <Dialog
          open={openDeleteObjetoREConfirm}
          onClose={handleCloseDeleteObjetoRE}
        >
          <DialogTitle>Confirmar Exclusão</DialogTitle>
          <DialogContent>
            <Typography>
              Tem certeza que deseja excluir o objeto de resseguro "<strong>{objetoREToDelete?.descricao}</strong>"?
              Esta ação não pode ser desfeita.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteObjetoRE}>
              Cancelar
            </Button>
            <Button onClick={handleConfirmDeleteObjetoRE} color="error" variant="contained">
              Excluir
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </MainLayout>
  );
};

export default EditarApolice; 